<template>
	<EditorWrapper>
		<div class="p-8">
			<div class="container max-w-6xl mx-auto">
				<article>
					<h1 class="text-3xl font-semibold text-gray-700">
						Editing Team Members on {{ domainname }}
					</h1>
					<ol class="space-y-2 pt-4" v-if="domainStore.domain">
						<li
							v-for="tm in domainStore.domain.agent.staff"
							:key="tm.alias"
							class="border-2 border-gray-200 rounded-lg text-gray-700"
							:class="[
								expandedId !== tm.alias
									? 'hover:bg-gray-100 transition ease-in-out'
									: '',
							]"
						>
							<div
								class="flex justify-between items-center p-4 cursor-pointer"
								@click="toggle(tm.alias)"
							>
								<div class="flex gap-4 items-center text-lg font-semibold">
									<ProfileImage size="md" :person="tm" border />
									{{ tm.full_name }}
								</div>
								<div class="place-self-center flex gap-2">
									<span>
										{{ expandedId === tm.alias ? "−" : "+" }}
									</span>
								</div>
							</div>
							<div
								v-if="expandedId === tm.alias"
								class="text-sm text-gray-700 px-4 pb-4"
							>
								<BaseEditor
									override-key="office.team.member_edits"
									override-type="team_member"
									:override-subkey="`.${tm.associate_id}.staff_copy`"
								/>
							</div>
						</li>
					</ol>
				</article>
			</div>
		</div>
	</EditorWrapper>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import BaseEditor from "@/components/editor/BaseEditor.vue";
import EditorWrapper from "@/components/editor/EditorWrapper.vue";
import ProfileImage from "@/components/ProfileImage.vue";
import useDomainStore from "@/stores/domain";

const route = useRoute();
const domainStore = useDomainStore();
const expandedId = ref(null);

const domainname = computed(() => domainStore.domain?.name);

async function toggle(id) {
  expandedId.value = expandedId.value === id ? null : id;
}
onMounted(async () => {
  await domainStore.ensureDomain(route.params.domain);
});
</script>
